import _ from 'lodash';
import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import IComp from '@/models/Comp';
import DoubleIndex from '@/models/DoubleIndex';
import IFeedData, { newFeedData } from '@/models/comp/IFeedData';
import SmartExchangeRequest from '@/models/requests/SmartExchangeRequest';
import GridColumnUtils from '@/utils/GridColumnUtils';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import Utils from '@/utils/QSUtils';
import { computed } from 'vue';
import { Actions, Getters, store, mlsStoreV36, Mutations, formFieldsStoreV36 } from '@/store';
import CompDataFeedsRequest from '../3.6/models/CompDataFeedsRequest';
import UpdateFeedRequest from '../3.6/models/UpdateFeedRequest';
import UAD from '@/services/3.6/uad/UAD';
import { FieldParser } from '@/services/3.6/uad/FieldParser';
import ISourceData from '@/models/comp/ISourceData';
import ICommonFieldData from '@/models/common/ICommonFieldData';
import IComps from '@/models/comp/IComps';
import { FieldNames } from '@/constants/FieldNames';
import IFormFieldRules from '@/models/form-field/IFormFieldRules';
import CompUtils from '@/models/comp/CompUtils';
import PublicRecordsFeedHelper from './helpers/PublicRecordsFeedHelper';
import CompDatasUtils from '@/models/comp/CompDatasUtils';
import LocalCompHelper from './helpers/LocalCompHelper';
import { SourceDataInitials } from '@/constants/SourceDataInitials';
import { newCompData } from '@/models/comp/ICompData';
import IRunFieldPrefsRequest, { newRunFieldPrefsRequest } from '../3.6/models/RunFieldPrefsRequest';
import IProcessCompRequest, { newProcessCompRequest } from '../3.6/models/IProcessCompRequest';
import ICompDatas from '@/models/comp/ICompDatas';
import FieldRulesHelper from './helpers/FieldRulesHelper';
import { FieldIds } from '@/constants/FieldIds';
import SmartExchangeFeedHelper from './helpers/SmartExchangeFeedHelper';
import SmartExchangeClaimsHelperV36 from './helpers/SmartExchangeClaimsHelper';
import IWorkingUADParams from '@/models/uad/IWorkingUADParams36';
import UserSettingsHelper from '@/store/3.6/helpers/UserSettingsHelper';
import ICompAddress from '@/models/CompAddress';
import IAddCompDataRequest from '../3.6/models/IAddCompDataRequest';
import CompsHelperV36 from './helpers/CompsHelper';
import FormsHelperV36 from './helpers/FormsHelper';
import CompAddressUtils from '@/models/comp/CompAddressUtils';
import IUpsertCompDataRequest, { newUpsertCompDataRequestByFieldId, newUpsertCompDataRequestByFieldName } from '../3.6/models/IUpsertCompDataRequest';
import IClearSourceDataRequest from '@/models/requests/IClearSourceDataRequest';
import CompPrioritiesHelperV36 from './helpers/CompPrioritiesHelper';
import CompTranslationsHelperV36 from './helpers/CompTranslationsHelper';
import FormsManager from '@/manager/3.6/FormsManager';

export const CompAddressGettersV36 = {
    Comps: 'Comps',
    CompCount: 'CompCount',
    CompByIdx: 'CompByIdx',
    HasComps: 'HasComps',
    ActiveComp: 'ActiveComp',
    CompByAddress: 'CompByAddress',
    LocalDatabaseCompByAddress: 'LocalDatabaseCompByAddress',
    CompIdxByAddress: 'CompIdxByAddress',
    ActiveFormCode: 'ActiveFormCode',
    GetAllDataPointsByFieldId: 'GetAllDataPointsByFieldId',
    ActiveCompFieldData: 'ActiveCompFieldData',
    ActiveCompFieldDataByFieldId: 'ActiveCompFieldDataByFieldId',
    OnlyShowReportRows: 'OnlyShowReportRows',
    OnlyShowDiscrepancyRows: 'OnlyShowDiscrepancyRows',
    ActiveCompEmptySourceData: 'ActiveCompEmptySourceData',
    GetFakeData: 'GetFakeData',
    ActiveCompFieldFillerCount: 'activeCompFieldFillerCount',
    ActiveCompSourceCounts: 'activeCompSourceCounts',
    IsSEColumnCollasped: 'isSEColumnCollasped',
    IsDBColumnCollasped: 'isDBColumnCollasped',
    GetCompSourceDataValueByFieldName: 'GetCompSourceDataValueByFieldName',
    GetCompSourceDataValueByFieldId: 'GetCompSourceDataValueByFieldId',
    LocalDatabaseComps: 'LocalDatabaseComps',
    GetRepeatIndicesForSection: 'GetRepeatIndicesForSection',
};

export const CompAddressActionsV36 = {
    ProcessComps: 'ProcessComps',
    ProcessComp: 'ProcessComp',
    FetchCompDataFeeds: 'FetchCompDataFeeds',
    ReFetchCompDataFeeds: 'ReFetchCompDataFeeds',
    FetchCompSmartExchangeData: 'FetchCompSmartExchangeData',
    MoveComp: 'MoveComp',
    RemoveComp: 'RemoveComp',
    TransferValueTranslations: 'TransferValueTranslations',
    TransferRunAllFieldDataPreferences: 'TransferRunAllFieldDataPreferences',
    UseAllData: 'UseAllData',
    UseAllSubCompData: 'UseAllSubCompData',
    ProcessUseAllData: 'ProcessUseAllData',
    OnlyShowReportRows: 'OnlyShowReportRows',
    OnlyShowDiscrepancyRows: 'OnlyShowDiscrepancyRows',
    TransferRunFieldRowTransferValueRulesOnAllCompsByFieldId: 'TransferRunFieldRowTransferValueRulesOnAllCompsByFieldId',
    TransferRunFieldRowTransferValueRulesOnCompsProcess: 'TransferRunFieldRowTransferValueRulesOnCompsProcess',
    TransferRunFieldRowTransferValueCasingOnAllComps: 'TransferRunFieldRowTransferValueCasingOnAllComps',
    TransferRunFieldRowTransferValueCasingOnAllCompsByFieldId: 'TransferRunFieldRowTransferValueCasingOnAllCompsByFieldId',
    TransferRunFieldRowTransferValueCasingOnAllUnVisitedCompsByFieldId: 'TransferRunFieldRowTransferValueCasingOnAllUnVisitedCompsByFieldId',
    TransferRunFieldRowTransferValueCasingOnCompsProcess: 'TransferRunFieldRowTransferValueCasingOnCompsProcess',
    UpdateAdditionalField: 'UpdateAdditionalField',
    GenerateFakeData: 'GenerateFakeData',
    UpdateInsertNotes: 'UpdateInsertNotes',
    ActiveCompFieldFillerCount: 'activeCompFieldFillerCount',
    ActiveCompSourceCounts: 'activeCompSourceCounts',
    LocalDatabaseComps: 'LocalDatabaseComps',
    UpdateLocalVersions: 'UpdateLocalVersions',
};

export const CompAddressMutationsV36 = {
    AddCompData: 'AddCompData',
    UpdateComp: 'UpdateComp',
    UpdateCompMLS: 'UpdateCompMLS',
    UpdateHasComps: 'UpdateHasComps',
    UpdateCompFeedData: 'UpdateCompFeedData',
    ResetCompLoading: 'ResetCompLoading',
    UpdateRemoveComp: 'UpdateRemoveComp',
    UpdateActiveComp: 'UpdateActiveComp',
    UpdateMoveComp: 'UpdateMoveComp',
    ResetActiveComp: 'ResetActiveComp',
    ResetCompNumber: 'ResetCompNumber',
    UpsertCompSourceDataByFieldId: 'UpsertCompSourceDataByFieldId',
    UpsertCompSourceDataBatchByFieldId: 'UpsertCompSourceDataBatchByFieldId',
    UpsertCompSourceDataBatchByFieldName: 'UpsertCompSourceDataBatchByFieldName',
    UpsertCompSourceDataByFieldName: 'UpsertCompSourceDataByFieldName',
    UpsertCompSourceDataValueByFieldName: 'UpsertCompSourceDataValueByFieldName',
    OnlyShowReportRows: 'OnlyShowReportRows',
    OnlyShowDiscrepancyRows: 'OnlyShowDiscrepancyRows',
    UpdateAdditionalField: 'UpdateAdditionalField',
    SetFakeData: 'SetFakeData',
    UpdateInsertNotes: 'UpdateInsertNotes',
    ActiveCompFieldFillerCount: 'activeCompFieldFillerCount',
    ActiveCompSourceCounts: 'activeCompSourceCounts',
    AddSubComp: 'addSubComp',
    ClearSubComps: 'clearSubComps',
    SetSEColumnCollasped: 'setSEColumnCollasped',
    SetDBColumnCollasped: 'setDBColumnCollasped',
    ClearCompSourceData: 'ClearCompSourceData',
    LocalDatabaseComps: 'LocalDatabaseComps',
    UpdateLocalVersions: 'UpdateLocalVersions',
    SetSilentActiveComp: 'SetSilentActiveComp',
};

// TODO: remove once the 3.6 form-fields metadata backend includes these fields; currently missing from formFieldsStoreV36.FormFields for Dropdowns.vue's map fields.
const MapDropdownFallbackFriendlyNames: Record<string, string> = {
    PU_SITE_INFLUENCE: 'Location',
    DA_CONSTQL: 'Quality of Construction',
    ST_SITEVW: 'View',
    AG_COND1: 'Condition',
    DA_DESAPL1: 'Design (Style)',
};

export const CompAddressStoreV36 = {
    namespaced: true,

    state() {
        const comps: IComp[] = [];
        const activeComp: IComp | null = null;
        const activeCompSourceCounts: IFeedData[] = [];
        const fakeData: ISourceData = {};
        const activeCompSubComps: IComp[] = [];
        const localDatabaseComps: IComp[] = [];

        return {
            comps,
            hasComps: false,
            activeFormCode: theLocalStorageUtils.get(LocalStorageKeys.formCode),
            activeCompFieldFillerCount: 0,
            activeCompSourceCounts,
            activeComp,
            activeCompSubComps,
            activeCompIsSECollapsed: true,
            activeCompIsdBCollapsed: true,
            onlyShowReportRows: true,
            onlyShowDiscrepancyRows: false,
            fakeData,
            localDatabaseComps,
        };
    },

    actions: {
        async [CompAddressActionsV36.LocalDatabaseComps](ctx: any, comp: IComp) {
            ctx.commit(CompAddressMutationsV36.LocalDatabaseComps, comp);
        },
        async [CompAddressActionsV36.UpdateLocalVersions](ctx: any, payload: any) {
            ctx.commit(CompAddressMutationsV36.UpdateLocalVersions, payload);
        },
        async [CompAddressActionsV36.ProcessComps](ctx: any, comps: IComps) {
            const feedsRequests: CompDataFeedsRequest[] = [];
            const duplicateRequests: IProcessCompRequest[] = [];

            // Phase 1: process and commit every Form Filler comp before any PR,
            // SE, DB, or MLS request is allowed to start.
            for (const idx in comps) {
                const processCompRequest = newProcessCompRequest(comps[idx]);
                processCompRequest.deferDataFeeds = true;
                const deferredWork = await ctx.dispatch(CompAddressActionsV36.ProcessComp, processCompRequest);
                if (deferredWork?.feedsRequest) {
                    feedsRequests.push(deferredWork.feedsRequest);
                } else if (deferredWork?.duplicateRequest) {
                    duplicateRequests.push(deferredWork.duplicateRequest);
                }
            }

            const activeCompIdx = Number(theLocalStorageUtils.get(LocalStorageKeys.defaultComp) ?? 0);
            CompsHelperV36.setActiveComp(activeCompIdx);

            // The comp addresses are known at this point, so release the grid for
            // rendering. The remaining work fills in behind the per-tab loaders.
            // Exclude the Subject entry - it's always present in comps, so counting it would mark
            // hasComps true even when there are zero actual comparables.
            const processedComps: IComp[] = store.getters[Getters.CompAddressesV36.Comps];
            if (processedComps.filter((c: IComp) => !CompUtils.isSubject(c)).length >= 1) {
                ctx.commit(CompAddressMutationsV36.UpdateHasComps, true);
            }
            // Yield to the event loop so the grid paints before the feed work starts.
            await Utils.sleep(0);

            // Phase 2: only after the Form Filler barrier, process duplicate payload
            // data and then start external source requests.
            for (const duplicateRequest of duplicateRequests) {
                duplicateRequest.deferDataFeeds = false;
                await ctx.dispatch(CompAddressActionsV36.ProcessComp, duplicateRequest);
            }

            // Not awaited - each comp clears its own tab loader as its feeds complete.
            Promise.all(
                feedsRequests.map((feedsRequest) =>
                    ctx.dispatch(CompAddressActionsV36.FetchCompDataFeeds, feedsRequest)
                )
            )
                .then(() => ctx.dispatch(CompAddressActionsV36.GenerateFakeData))
                .catch((error) => console.log(`CompAddressStoreV36.ProcessComps(Action), Error fetching comp data feeds[${error}]`));
        },
        async [CompAddressActionsV36.ProcessComp](ctx: any, request: IProcessCompRequest): Promise<any> {
            const getterComps = store.getters[Getters.CompAddressesV36.Comps];

            // Skip address with missing address1 and zipcode
            const comp = request.comp;
            if (comp.address.address1 === '' || comp.address.zipCode === '') {
                return;
            }

            // Exclude duplicate comp based on address1 and unit number
            const itemIdx = store.getters[Getters.CompAddressesV36.CompIdxByAddress](comp.address);
            if (itemIdx === -1) {
                // Exclude the Subject entry - it's always present in comps, so counting it would mark
                // hasComps true even when there are zero actual comparables. Also count the comp being
                // added right now (not yet committed to getterComps) if it isn't the Subject itself,
                // otherwise adding the very first real comp never flips hasComps to true.
                if (!CompUtils.isSubject(comp) || (getterComps as IComp[]).filter((c: IComp) => !CompUtils.isSubject(c)).length >= 1) {
                    ctx.commit(CompAddressMutationsV36.UpdateHasComps, true);
                }

                comp.address.address2 = GridColumnUtils.buildAddress2(comp.address);
                comp.compKey = Utils.isKeyInObject(comp, 'compKey') ? comp.compKey : '';
                comp.compNumber = getterComps.length;
                comp.compType = Utils.isKeyInObject(comp, 'compType') ? comp.compType : 'Sale';
                comp.formCode = theLocalStorageUtils.get(LocalStorageKeys.formCode) ?? '';
                comp.isActive = false;
                comp.isLoading = true;
                comp.isSubject = comp.compType ? (comp.compType.toLowerCase() === 'subject' ? true : false) : false;
                comp.localVersions = Utils.isKeyInObject(comp, 'localVersions') ? comp.localVersions : [];
                comp.notesData = Utils.isKeyInObject(comp, 'notesData') ? comp.notesData : [];
                comp.propertyPhoto = Utils.isKeyInObject(comp, 'propertyPhoto') ? comp.propertyPhoto : '';
                comp.qsGuid = Utils.uuid();

                if (!Utils.isKeyInObject(comp, 'sourceData')) {
                    comp.sourceData = [];
                    comp.hasVisited = false;
                } else {
                    // Use the synchronously cached form fields (loaded at launch) to avoid introducing
                    // an async gap here. All ProcessComp calls are dispatched concurrently without await,
                    // so any async gap causes all of them to read an empty getterComps snapshot, which
                    // prevents UpdateHasComps from ever being set and triggers the JumpStart popup.
                    const cachedFormFields: any[] = formFieldsStoreV36.FormFields ?? [];
                    if (cachedFormFields.length > 0) {
                        const allowedNames = new Set(
                            cachedFormFields
                                .filter((field: any) => comp.isSubject ? field?.isSubjectField === true : field?.isSubjectField !== true)
                                .map((field: any) => String(field?.fieldName || ''))
                        );
                        const allFormFieldNames = new Set(
                            cachedFormFields.map((field: any) => String(field?.fieldName || ''))
                        );
                        const concatenatedChildFieldNames = new Set(
                            Object.values(GridColumnUtils.getParentChildFieldsList()).flat()
                        );
                        comp.sourceData = comp.sourceData.filter((compData: any) => {
                            const fieldName = String(compData?.fieldName || '');
                            const baseFieldName = fieldName.split('-').pop() || fieldName;
                            return allowedNames.has(fieldName) ||
                                allowedNames.has(baseFieldName) ||
                                (fieldName.includes('-') && (
                                    allFormFieldNames.has(baseFieldName) ||
                                    concatenatedChildFieldNames.has(baseFieldName)
                                ));
                        });
                    }

                    comp.hasVisited = CompDatasUtils.hasInitialsOtherThanFormFiller(comp.sourceData);
                }

                ctx.commit(CompAddressMutationsV36.UpdateComp, comp);

                const feedsRequest: CompDataFeedsRequest = {
                    address: comp.address,
                    qsGuid: comp.qsGuid,
                    formCode: comp.formCode ?? '',
                    compsGuid: theLocalStorageUtils.get(LocalStorageKeys.almCompId) ?? '',
                    isSubject: comp.isSubject,
                    fetch: [SourceDataInitials.PublicRecords, SourceDataInitials.SmartExchange, SourceDataInitials.Database, SourceDataInitials.Mls],
                };
                if (request.deferDataFeeds) {
                    return { feedsRequest };
                }

                await ctx.dispatch(CompAddressActionsV36.FetchCompDataFeeds, feedsRequest);
            } else {
                if (request.deferDataFeeds) {
                    return { duplicateRequest: request };
                }

                // Check to see if MLS exists in duplicate payload.
                if (comp.sourceDataMLS) {
                    if (!comp.sourceDataMLS.sourceData || Utils.isObjectEmpty(comp.sourceDataMLS.sourceData)) {
                        // Fall back to the new ConvertMLSMapperDataToUAD36 feed data store (already QS field names).
                        const address1UnitNoZipCode = CompAddressUtils.getAddress1UnitNoAndZipCode(comp.address);
                        const mlsFeedData = mlsStoreV36.MlsFeedDataByAddress1UnitNoZipCode(address1UnitNoZipCode);
                        // Clone - mlsFeedData is a live reference into mlsStoreV36 state.
                        comp.sourceDataMLS.sourceData = mlsFeedData?.sourceData ? _.cloneDeep(mlsFeedData.sourceData) : {};
                    }

                    // const formCode = theLocalStorageUtils.get(LocalStorageKeys.formCode);
                    // const claims = await SmartExchangeClaimsHelperV36.getClaims();
                    // const uadParams: IWorkingUADParams = {
                    //     parser: new FieldParser() as any,
                    //     formCode: formCode ?? '',
                    //     sourceInitial: SourceDataInitials.Mls,
                    //     sourceData: comp.sourceDataMLS.sourceData ?? {},
                    //     isSEOptedIn: claims.isOptedIn ?? false,
                    // };
                    // comp.sourceDataMLS.sourceData = await UAD.parser(uadParams);

                    ctx.commit(CompAddressMutationsV36.UpdateCompMLS, {
                        idx: itemIdx,
                        mlsData: comp.sourceDataMLS,
                    });

                    // Only rerun the DataPreferences / ValueTranslations if comp has not been visited
                    const storeComps = store.getters[Getters.CompAddressesV36.Comps];
                    const storeComp = storeComps[itemIdx];
                    if (!storeComp.hasVisited || request.onUpdateRunPreferencesWhenHasVisited) {
                        await CompsHelperV36.backFillMissingFields(storeComp.address);

                        //console.log(`CompAddressStoreV36.ProcessComp(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Dispatching TransferRunAllFieldDataPreferences`);
                        const runFieldPrefs = newRunFieldPrefsRequest(storeComp);
                        runFieldPrefs.overrideSourceInitial = true;
                        await ctx.dispatch(CompAddressActionsV36.TransferRunAllFieldDataPreferences, runFieldPrefs);

                        //console.log(`CompAddressStoreV36.ProcessComp(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Dispatching TransferValueTranslations`);
                        await ctx.dispatch(CompAddressActionsV36.TransferValueTranslations, storeComp);
                    }
                }
            }

            return undefined;
        },
        async [CompAddressActionsV36.FetchCompDataFeeds](ctx: any, feedsRequest: CompDataFeedsRequest) {
            for (const idx in feedsRequest.fetch) {
                let feedData: IFeedData = newFeedData();
                switch (feedsRequest.fetch[idx].toLowerCase()) {
                    case SourceDataInitials.Database:
                        feedData = await LocalCompHelper.fetchFeedData(feedsRequest);
                        // Need to get subComps for each address for both the phot gallery and photo view button count
                        await LocalCompHelper.fetchFeedDataSubComps(feedsRequest);
                        break;
                    case SourceDataInitials.SmartExchange:
                        feedData = await ctx.dispatch(CompAddressActionsV36.FetchCompSmartExchangeData, feedsRequest);
                        // Need to get subComps for each address for both the photo gallery and photo view button count
                        await SmartExchangeFeedHelper.fetchFeedDataSubComps(feedsRequest);
                        break;
                    case SourceDataInitials.PublicRecords: 
                        {
                            const prFeedData = await PublicRecordsFeedHelper.fetch(feedsRequest);
                            feedData = prFeedData ? prFeedData : newFeedData();
                            break;
                        }
                    case SourceDataInitials.Mls:
                        {
                            const mlsPropertyItem = mlsStoreV36.MlsPropertyFieldValueByAddress(feedsRequest.address);
                            if (mlsPropertyItem && !Utils.isObjectEmpty(mlsPropertyItem)) {
                                feedData = {
                                    sourceData: mlsPropertyItem,
                                };
                            } else {
                                // Fall back to the new ConvertMLSMapperDataToUAD36 feed data store (already QS field names).
                                const address1UnitNoZipCode = CompAddressUtils.getAddress1UnitNoAndZipCode(feedsRequest.address);
                                const mlsFeedData = mlsStoreV36.MlsFeedDataByAddress1UnitNoZipCode(address1UnitNoZipCode);
                                // Clone - mlsFeedData is a live reference into mlsStoreV36 state.
                                feedData = {
                                    sourceData: mlsFeedData?.sourceData ? _.cloneDeep(mlsFeedData.sourceData) : {},
                                };
                            }
                        }
                        break;
                }

                //UAD parser
                // if (Utils.isKeyInObject(feedData, 'sourceData') && !Utils.isObjectEmpty(feedData.sourceData)) {
                //     const formCode = theLocalStorageUtils.get(LocalStorageKeys.formCode);
                //     const claims = await SmartExchangeClaimsHelperV36.getClaims();
                //     const uadParams: IWorkingUADParams = {
                //         parser: new FieldParser() as any,
                //         formCode: formCode ?? '',
                //         sourceInitial: feedsRequest.fetch[idx].toLowerCase(),
                //         sourceData: feedData.sourceData ?? {},
                //         isSEOptedIn: claims.isOptedIn ?? false,
                //     };
                //     feedData.sourceData = await UAD.parser(uadParams);
                // }

                const updateFeedRequest: UpdateFeedRequest = {
                    feedData: feedData,
                    qsGuid: feedsRequest.qsGuid,
                    sourceInitial: feedsRequest.fetch[idx].toLowerCase(),
                };

                ctx.commit(CompAddressMutationsV36.UpdateCompFeedData, updateFeedRequest);
            }
            ctx.commit(CompAddressMutationsV36.ResetCompLoading, feedsRequest.qsGuid);

            //Run transfer column updates
            const comps = computed(() => store.getters[Getters.CompAddressesV36.Comps]);
            const compIdx = comps.value.findIndex((f: any) => f.qsGuid === feedsRequest.qsGuid);
            if (compIdx !== -1) {
                const comp = comps.value[compIdx];
                await CompsHelperV36.backFillMissingFields(comp.address);

                //console.log(`CompAddressStoreV36.FetchCompDataFeeds(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Dispatching TransferRunAllFieldDataPreferences`);
                const runFieldPrefs = newRunFieldPrefsRequest(comp);
                await ctx.dispatch(CompAddressActionsV36.TransferRunAllFieldDataPreferences, runFieldPrefs);
                //console.log(`CompAddressStoreV36.FetchCompDataFeeds(Action), address[${CompAddressUtils.getShortDescription(comp.address)}], Dispatching TransferValueTranslations`);
                await ctx.dispatch(CompAddressActionsV36.TransferValueTranslations, comp);
            }
        },
        async [CompAddressActionsV36.ReFetchCompDataFeeds](ctx: any, payload: any) {
            const feedsRequest: CompDataFeedsRequest = {
                address: payload.comp.address,
                qsGuid: payload.comp.qsGuid,
                formCode: payload.comp.formCode ?? '',
                compsGuid: theLocalStorageUtils.get(LocalStorageKeys.almCompId) ?? '',
                isSubject: payload.comp.isSubject,
                fetch: payload.refetch,
            };
            ctx.dispatch(CompAddressActionsV36.FetchCompDataFeeds, feedsRequest);
        },
        async [CompAddressActionsV36.FetchCompSmartExchangeData](ctx: any, feedsRequest: CompDataFeedsRequest): Promise<IFeedData> {
            const p2id = theLocalStorageUtils.get(LocalStorageKeys.p2id);

            const claims = await SmartExchangeClaimsHelperV36.getClaims();
            const seRequest: SmartExchangeRequest = {
                formCode: feedsRequest.formCode,
                isSubject: feedsRequest.isSubject,
                address: feedsRequest.address,
                p2Id: p2id ?? '',
                isOptedIn: claims.isOptedIn ?? false,
                optInUrl: claims.optInUrl ?? '',
                userAccessToken: claims.userAccessToken ?? '',
            };

            const result = await SmartExchangeFeedHelper.fetch(seRequest);
            return result;
        },
        [CompAddressActionsV36.RemoveComp](ctx: any, idx: number) {
            ctx.commit(CompAddressMutationsV36.UpdateRemoveComp, idx);
            ctx.commit(CompAddressMutationsV36.ResetCompNumber);
        },
        [CompAddressActionsV36.MoveComp](ctx: any, indexes: DoubleIndex) {
            ctx.commit(CompAddressMutationsV36.UpdateMoveComp, indexes);
            ctx.commit(CompAddressMutationsV36.ResetCompNumber);
        },
        async [CompAddressActionsV36.TransferRunAllFieldDataPreferences](ctx: any, payload: IRunFieldPrefsRequest) {
            // If comp is subject and SubjectCascade is disabled then do not run data preferences
            const runSubjectCascade = payload.comp.isSubject && UserSettingsHelper.isSubjectCascadeDisabled() ? false : true;

            const compSourceData: ICompDatas = payload.comp.sourceData ? _.cloneDeep(payload.comp.sourceData) : [];
            const formFields = await FormsHelperV36.getFormFields();
            const formFieldsToProcess = payload.comp.isSubject
                ? formFields.filter((fieldData: any) => fieldData?.isSubjectField === true)
                : formFields.filter((fieldData: any) => fieldData?.isSubjectField !== true);

            for (const fieldData of formFieldsToProcess) {
                const compData = compSourceData.find((cd) => cd.fieldName === fieldData.fieldName);
                
                if (compData) {
                    const request = newUpsertCompDataRequestByFieldName(payload.comp, fieldData.fieldName);
                    request.fieldId = fieldData.fieldId;
                    request.fieldRulesApplied = false;
                    request.description = 'CompAddressStoreV36.TransferRunAllFieldDataPreferences()';
                    store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataByFieldName, request);

                    // Skip all form filler comp data and any comp data with some source initial unless explicitly overridden
                    // We don't normally want to overwrite the Data Preference Order
                    if (compData.sourceInitial === SourceDataInitials.FormFiller || (!payload.overrideSourceInitial && compData.sourceInitial !== '')) {
                        continue;
                    } else if (compData.sourceInitial === '' && compData.value !== '') {
                        // If field data has a value but the sourceInitial is empty, treat is as FF
                        const request = newUpsertCompDataRequestByFieldName(payload.comp, fieldData.fieldName);
                        request.sourceInitial = SourceDataInitials.FormFiller;
                        request.description = 'CompAddressStoreV36.TransferRunAllFieldDataPreferences()';
                        store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataByFieldName, request);

                        continue;
                    }
                }

                if (!runSubjectCascade) {
                    continue;
                }

                // Run Data Priorities based on user priorities
                await CompPrioritiesHelperV36.runOnField(payload.comp, fieldData.fieldId);
            }
        },
        [CompAddressActionsV36.UpdateAdditionalField](ctx: any, payload: any) {
            ctx.commit(CompAddressMutationsV36.UpdateAdditionalField, payload);
        },
        async [CompAddressActionsV36.TransferValueTranslations](ctx: any, comp: IComp) {
            if (comp.sourceData) {
                await CompPrioritiesHelperV36.syncAllFlattenedRepeatableFields(comp);
                const excludeNoValueAndNoSourceInitial = comp.compNumber === 0 && UserSettingsHelper.isSubjectCascadeDisabled();
                await CompTranslationsHelperV36.run(comp, excludeNoValueAndNoSourceInitial);
            }
        },
        async [CompAddressActionsV36.TransferRunFieldRowTransferValueRulesOnAllCompsByFieldId](ctx: any, fieldId: number) {
            const getterComps = store.getters[Getters.CompAddressesV36.Comps];
            for (const idx in getterComps) {
                const comp = getterComps[idx];

                await store.dispatch(Actions.CompAddressesV36.TransferRunFieldRowTransferValueRulesOnCompsProcess, {
                    comp: comp,
                    fieldId: fieldId,
                });
            }
        },
        async [CompAddressActionsV36.TransferRunFieldRowTransferValueRulesOnCompsProcess](ctx: any, payload: any) {
            const comp: IComp = payload.comp;
            const fieldId: number = payload.fieldId;
            if (comp.compNumber === 0 && UserSettingsHelper.isSubjectCascadeDisabled()) {
                // Return if Subject transfer column is locked
                return;
            }

            await CompPrioritiesHelperV36.syncFlattenedRepeatableField(comp, fieldId);
            await CompTranslationsHelperV36.runOnField(comp, fieldId);
        },
        async [CompAddressActionsV36.TransferRunFieldRowTransferValueCasingOnAllComps](ctx: any) {
            const getterComps = store.getters[Getters.CompAddressesV36.Comps];
            const formFields = await FormsHelperV36.getFormFields();
            for (const idx in getterComps) {
                const comp = getterComps[idx];
                for (const fieldIdx in formFields) {
                    const fieldId = formFields[fieldIdx].fieldId;
                    if (fieldId === FieldIds.CompPhoto) {
                        // Skip comp photo casing because of photo url
                        continue;
                    }

                    store.dispatch(Actions.CompAddressesV36.TransferRunFieldRowTransferValueCasingOnCompsProcess, {
                        comp: comp,
                        fieldId: fieldId,
                    });
                }
            }
        },
        async [CompAddressActionsV36.TransferRunFieldRowTransferValueCasingOnAllCompsByFieldId](ctx: any, payload: any) {
            const fieldId = typeof payload === 'number' ? payload : payload.fieldId;
            const preferredCasing = typeof payload === 'number' ? undefined : payload.preferredCasing;
            const getterComps = store.getters[Getters.CompAddressesV36.Comps];
            for (const idx in getterComps) {
                const comp = getterComps[idx];

                await store.dispatch(Actions.CompAddressesV36.TransferRunFieldRowTransferValueCasingOnCompsProcess, {
                    comp: comp,
                    fieldId: fieldId,
                    preferredCasing: preferredCasing,
                });
            }
        },
        [CompAddressActionsV36.TransferRunFieldRowTransferValueCasingOnAllUnVisitedCompsByFieldId](ctx: any, fieldId: number) {
            const getterComps = store.getters[Getters.CompAddressesV36.Comps];
            for (const idx in getterComps.filter((obj: { hasVisited: boolean }) => !obj.hasVisited)) {
                const comp = getterComps[idx];

                store.dispatch(Actions.CompAddressesV36.TransferRunFieldRowTransferValueCasingOnCompsProcess, {
                    comp: comp,
                    fieldId: fieldId,
                });
            }
        },
        async [CompAddressActionsV36.TransferRunFieldRowTransferValueCasingOnCompsProcess](ctx: any, payload: any) {
            const comp = payload.comp;
            const fieldId = payload.fieldId;

            if (Utils.isKeyInObject(comp, 'sourceData')) {
                const parentFieldId = Math.floor(fieldId);
                const fieldData = payload.preferredCasing ? null : await FormsManager.getFieldDataById(parentFieldId);
                const preferredCasing = payload.preferredCasing || fieldData?.preferredCasing || 'Lower';
                const matchingCompDatas = comp.sourceData.filter(
                    (compData: any) =>
                        typeof compData.fieldId === 'number' &&
                        (fieldId % 1 === 0 ? Math.floor(compData.fieldId) === parentFieldId : compData.fieldId === fieldId)
                );
                const updates: any[] = [];

                for (const compData of matchingCompDatas) {
                    const value = GridColumnUtils.transferValueCasing(compData.value, preferredCasing);
                    updates.push({
                        fieldName: compData.fieldName,
                        fieldId: compData.fieldId,
                        value: value,
                    });
                }

                if (updates.length > 0) {
                    store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataBatchByFieldName, {
                        comp: comp,
                        updates: updates,
                    });
                }
            }
        },
        async [CompAddressActionsV36.UseAllData](ctx: any, initials: string) {
            const formFields = await FormsManager.getFormFields();
            const activeComp = computed(() => store.getters[Getters.CompAddressesV36.ActiveComp]);
            const comp = activeComp.value;

            let fieldRules: IFormFieldRules = [];
            const directFieldValuesByName: Record<string, string> = {};
            const repeatableFieldValuesByName: Record<string, string> = {};
            const sourceData = CompUtils.getDataSourceSourceData(comp, initials);
            if (sourceData) {

                fieldRules = GridColumnUtils.getUseAllDataValues(sourceData, formFields);

                const fieldRulesById = new Map<number, any>();
                for (const rule of fieldRules) {
                    if (rule?.fieldId !== undefined && rule?.fieldId !== null) {
                        fieldRulesById.set(rule.fieldId, rule);
                    }
                }

                for (const [fieldName, rawValue] of Object.entries(sourceData)) {
                    if (rawValue === '' || rawValue === null || rawValue === undefined) {
                        continue;
                    }

                    const isRepeatablePayloadKey = /^[A-Za-z]+-\d+-/.test(fieldName);
                    if (isRepeatablePayloadKey) {
                        repeatableFieldValuesByName[fieldName] = String(rawValue);
                    }

                    const compData = Array.isArray(comp?.sourceData)
                        ? comp.sourceData.find((cd: any) => cd?.fieldName === fieldName)
                        : null;

                    if (compData && compData.fieldId !== undefined && compData.fieldId !== null) {
                        if (!fieldRulesById.has(compData.fieldId)) {
                            fieldRulesById.set(compData.fieldId, {
                                fieldId: compData.fieldId,
                                value: String(rawValue),
                            });
                        }
                    } else {
                        directFieldValuesByName[fieldName] = String(rawValue);
                    }
                }

                fieldRules = Array.from(fieldRulesById.values());
            }

            store.dispatch(Actions.CompAddressesV36.ProcessUseAllData, {
                comp: comp,
                fieldRules: fieldRules,
                initials: initials,
                // Use -1 to explicitly represent the main column when applying Use All.
                // This allows the grid to distinguish main-column bulk selections from sub-comp selections.
                subCompIdx: -1,
                directFieldValuesByName,
                repeatableFieldValuesByName,
            });
        },
        async [CompAddressActionsV36.UseAllSubCompData](ctx: any, payload: any) {
            const initials = payload.initials;
            const subCompIdx = payload.subCompIdx;
            const formFields = await FormsManager.getFormFields();
            const activeComp = computed(() => store.getters[Getters.CompAddressesV36.ActiveComp]);
            const comp = activeComp.value;

            let fieldRules: IFormFieldRules = [];
            const directFieldValuesByName: Record<string, string> = {};
            const repeatableFieldValuesByName: Record<string, string> = {};
            const sourceData = CompUtils.getDataSourceSubSourceData(comp, initials, subCompIdx);
            if (sourceData) {

                fieldRules = GridColumnUtils.getUseAllDataValues(sourceData, formFields);

                const fieldRulesById = new Map<number, any>();
                for (const rule of fieldRules) {
                    if (rule?.fieldId !== undefined && rule?.fieldId !== null) {
                        fieldRulesById.set(rule.fieldId, rule);
                    }
                }

                for (const [fieldName, rawValue] of Object.entries(sourceData)) {
                    if (rawValue === '' || rawValue === null || rawValue === undefined) {
                        continue;
                    }

                    const isRepeatablePayloadKey = /^[A-Za-z]+-\d+-/.test(fieldName);
                    if (isRepeatablePayloadKey) {
                        repeatableFieldValuesByName[fieldName] = String(rawValue);
                    }

                    const compData = Array.isArray(comp?.sourceData)
                        ? comp.sourceData.find((cd: any) => cd?.fieldName === fieldName)
                        : null;

                    if (compData && compData.fieldId !== undefined && compData.fieldId !== null) {
                        if (!fieldRulesById.has(compData.fieldId)) {
                            fieldRulesById.set(compData.fieldId, {
                                fieldId: compData.fieldId,
                                value: String(rawValue),
                            });
                        }
                    } else {
                        directFieldValuesByName[fieldName] = String(rawValue);
                    }
                }

                fieldRules = Array.from(fieldRulesById.values());
            }

            store.dispatch(Actions.CompAddressesV36.ProcessUseAllData, {
                comp: comp,
                fieldRules: fieldRules,
                initials: initials,
                subCompIdx: subCompIdx,
                directFieldValuesByName,
                repeatableFieldValuesByName,
            });
        },
        async [CompAddressActionsV36.ProcessUseAllData](ctx: any, payload: any) {
            const comp = payload.comp;
            const submitFieldRules = payload.fieldRules;
            const initials = payload.initials;
            const subCompIdx = payload.subCompIdx;
            const directFieldValuesByName = payload.directFieldValuesByName || {};
            const repeatableFieldValuesByName = payload.repeatableFieldValuesByName || {};
            if (submitFieldRules.length > 0) {
                const resultFieldRules = await FieldRulesHelper.runFieldRulesForComp(comp, submitFieldRules);

                // Rules service can omit some repeatable rows when fieldIds share the same parent id.
                // Preserve those values by falling back to submitted rules for any missing fieldId.
                const rulesToApply = Array.isArray(resultFieldRules) ? _.cloneDeep(resultFieldRules) : [];
                const appliedFieldIds = new Set(rulesToApply.map((rule: any) => Number(rule?.fieldId)));
                for (const submitRule of submitFieldRules) {
                    const submitFieldId = Number(submitRule?.fieldId);
                    if (!Number.isNaN(submitFieldId) && !appliedFieldIds.has(submitFieldId)) {
                        rulesToApply.push({
                            fieldId: submitFieldId,
                            value: String(submitRule?.value ?? ''),
                            fieldRulesApplied: false,
                        });
                    }
                }

                for (const resultFieldRule of rulesToApply) {
                    const resultValue = String(resultFieldRule?.value ?? '').trim();
                    if (resultValue === '') {
                        continue;
                    }

                    // Dont use Comp Photo result from rules endpoint.  URL's should not have casing applied
                    if (resultFieldRule.fieldId === FieldIds.CompPhoto) {
                        resultFieldRule.value = submitFieldRules.find((f: any) => f.fieldId === resultFieldRule.fieldId) ? submitFieldRules.find((f: any) => f.fieldId === resultFieldRule.fieldId).value : resultFieldRule.value;
                    }

                    const request = newUpsertCompDataRequestByFieldId(comp, resultFieldRule.fieldId);
                    request.value = resultFieldRule.value;
                    request.sourceInitial = initials.toLowerCase();
                    request.fieldRulesApplied = resultFieldRule.fieldRulesApplied;
                    request.sourceInitialIdx = subCompIdx;
                    request.description = 'CompAddressStoreV36.ProcessUseAllData()';
                    store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataByFieldId, request);
                }
            }

            for (const [fieldName, value] of Object.entries(directFieldValuesByName)) {
                const directValue = String(value ?? '').trim();
                if (directValue === '') {
                    continue;
                }

                const request = newUpsertCompDataRequestByFieldName(comp, fieldName);
                request.value = directValue;
                request.sourceInitial = initials.toLowerCase();
                request.fieldRulesApplied = false;
                request.sourceInitialIdx = subCompIdx;
                request.description = 'CompAddressStoreV36.ProcessUseAllData() direct fieldName fallback';
                store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataByFieldName, request);
            }

            // Guarantee repeatable payload rows are preserved by fieldName regardless of
            // field-rules normalization or fieldId collisions.
            for (const [fieldName, value] of Object.entries(repeatableFieldValuesByName)) {
                const repeatableValue = String(value ?? '').trim();
                if (repeatableValue === '') {
                    continue;
                }

                const request = newUpsertCompDataRequestByFieldName(comp, fieldName);
                request.value = repeatableValue;
                request.sourceInitial = initials.toLowerCase();
                request.fieldRulesApplied = false;
                request.sourceInitialIdx = subCompIdx;
                request.description = 'CompAddressStoreV36.ProcessUseAllData() repeatable fieldName guarantee';
                store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataByFieldName, request);
            }

        },
        [CompAddressActionsV36.OnlyShowReportRows](ctx: any, isActive: boolean) {
            ctx.commit(CompAddressMutationsV36.OnlyShowReportRows, isActive);
        },
        [CompAddressActionsV36.OnlyShowDiscrepancyRows](ctx: any, isActive: boolean) {
            ctx.commit(CompAddressMutationsV36.OnlyShowDiscrepancyRows, isActive);
        },
        async [CompAddressActionsV36.GenerateFakeData](ctx: any) {
            const fakeSourceData: ISourceData = {};
            const subjectComp = computed(() => store.getters[Getters.CompAddressesV36.CompByIdx](0));
            const comp = subjectComp.value;

            const formFields = await FormsManager.getFormFields();
            if (!Utils.isObjectEmpty(formFields)) {
                for (const fieldIdx in formFields) {
                    const fieldName = formFields[fieldIdx]['fieldName'];

                    if (fieldName === FieldNames.CompPhoto) continue;

                    const compIdx = comp.sourceData.findIndex((f: any) => f.fieldName === fieldName);
                    if (compIdx !== -1) {
                        fakeSourceData[fieldName] = Utils.ranStr(comp.sourceData[compIdx].value.length);
                    } else {
                        fakeSourceData[fieldName] = Utils.ranStr(7);
                    }
                }

                ctx.commit(CompAddressMutationsV36.SetFakeData, fakeSourceData);
            }
        },
        [CompAddressActionsV36.UpdateInsertNotes](ctx: any, payload: ICommonFieldData) {
            ctx.commit(CompAddressMutationsV36.UpdateInsertNotes, payload);
        },
        [CompAddressActionsV36.ActiveCompFieldFillerCount](ctx: any, count: number) {
            ctx.commit(CompAddressMutationsV36.ActiveCompFieldFillerCount, count);
        },
        [CompAddressActionsV36.ActiveCompSourceCounts](ctx: any, payload: IFeedData[]) {
            ctx.commit(CompAddressMutationsV36.ActiveCompSourceCounts, payload);
        },
    },

    getters: {
        [CompAddressGettersV36.LocalDatabaseComps](state: any): IComp[] {
            return state.localDatabaseComps ? state.localDatabaseComps : [];
        },
        [CompAddressGettersV36.Comps](state: any): IComp[] {
            return state.comps ? state.comps : [];
        },
        [CompAddressGettersV36.CompCount](state: any): number {
            return state.comps ? state.comps.length : 0;
        },
        [CompAddressGettersV36.HasComps](state: any): boolean {
            return state.hasComps ? state.hasComps : false;
        },
        [CompAddressGettersV36.ActiveComp](state: any): IComp {
            return state.activeComp ? state.activeComp : {} as IComp;
        },
        [CompAddressGettersV36.CompByIdx]:
            (state: any) =>
            (compIdx: number): IComp => {
                return state.comps[compIdx] ? state.comps[compIdx] : {} as IComp;
            },
        [CompAddressGettersV36.CompByAddress]: (state: any) => (compAddress: ICompAddress) => {
            const storeComps: IComps = store.getters[Getters.CompAddressesV36.Comps];
            const comp = storeComps.find((c) => c.address.address1 === compAddress.address1 && c.address.unitNumber === compAddress.unitNumber && c.address.zipCode === compAddress.zipCode);
            return comp;
        },
        [CompAddressGettersV36.LocalDatabaseCompByAddress]: (state: any) => (compAddress: ICompAddress) => {
            const storeComps: IComps = store.getters[Getters.CompAddressesV36.LocalDatabaseComps];
            const comp = storeComps.find((c) => c.address.address1 === compAddress.address1 && c.address.unitNumber === compAddress.unitNumber && c.address.zipCode === compAddress.zipCode);
            return comp;
        },
        [CompAddressGettersV36.CompIdxByAddress]: (state: any) => (compAddress: ICompAddress) => {
            let compIdx = -1;
            const getterComps = store.getters[Getters.CompAddressesV36.Comps];
            const itemIdx = getterComps.findIndex((f: any) => f.address.address1 === compAddress.address1 && f.address.unitNumber === compAddress.unitNumber && f.address.zipCode === compAddress.zipCode);
            if (itemIdx !== -1) {
                compIdx = itemIdx;
            }
            return compIdx;
        },
        [CompAddressGettersV36.ActiveFormCode](state: any) {
            return state.activeFormCode ? state.activeComp.formCode : '1004UAD';
        },
        [CompAddressGettersV36.GetCompSourceDataValueByFieldName]: (state: any) => (payload: any) => {
            const compIdx = store.getters[Getters.CompAddressesV36.CompIdxByAddress](payload.comp.address);
            if (compIdx !== -1) {
                const itemIdx = payload.comp.sourceData.findIndex((f: any) => f.fieldName === payload.fieldName);
                if (itemIdx !== -1) {
                    if (Utils.isKeyInObject(payload.comp.sourceData[itemIdx], payload.name)) {
                        return payload.comp.sourceData[itemIdx][payload.name];
                    }
                }
            }
            return null;
        },
        [CompAddressGettersV36.GetCompSourceDataValueByFieldId]: (state: any) => (payload: any) => {
            const compIdx = store.getters[Getters.CompAddressesV36.CompIdxByAddress](payload.comp.address);
            if (compIdx !== -1) {
                const itemIdx = payload.comp.sourceData.findIndex((f: any) => f.fieldId === payload.fieldId);
                if (itemIdx !== -1) {
                    if (Utils.isKeyInObject(payload.comp.sourceData[itemIdx], payload.name)) {
                        return payload.comp.sourceData[itemIdx][payload.name];
                    }
                }
            }
            return null;
        },
        [CompAddressGettersV36.GetAllDataPointsByFieldId]: (state: any) => (fieldName: string[]) => {
            const result = [];
            const active = { ...state.activeComp };
            const formFields = formFieldsStoreV36.FormFields;

            // This will dynamically grad all data sources key names collected
            const dataSources = Object.keys(active).filter((key) => key.includes('sourceData'));

            for (const idx in fieldName) {
                const field = fieldName[idx];

                let selectedData = {};
                const sourceData = [];
                for (const sourceIdx in dataSources) {
                    const dataSource = dataSources[sourceIdx];

                    // Transfer Data: sourceData
                    if (dataSource.length === 10) {
                        const rowIdx = state.activeComp[dataSource].findIndex((f: any) => f.fieldName === field);
                        if (rowIdx !== -1) {
                            const rowItem = state.activeComp[dataSource][rowIdx];
                            if (rowItem.value !== '') {
                                selectedData = {
                                    value: rowItem.value,
                                    fieldRulesApplied: false, // TODO: Need to add fieldRulesApplied property to each field in the sourceData payload and reference
                                    sourceInitial: rowItem.sourceInitial === '' ? SourceDataInitials.FormFiller : rowItem.sourceInitial.toLowerCase(),
                                };
                            }
                        }

                        // All other sources: sourceDataPR, sourceDataSE, etc
                    } else {
                        if (!Utils.isObjectEmpty(state.activeComp[dataSource])) {
                            if (Utils.isKeyInObject(state.activeComp[dataSource], 'sourceData')) {
                                if (Utils.isKeyInObject(state.activeComp[dataSource]['sourceData'], field)) {
                                    if (state.activeComp[dataSource]['sourceData'][field] !== '' && state.activeComp[dataSource]['sourceData'][field] !== null) {
                                        sourceData.push({
                                            value: state.activeComp[dataSource]['sourceData'][field],
                                            sourceInitial: dataSource.slice(10).toLowerCase(),
                                        });
                                    }
                                }
                            }
                        }
                    }
                }

                let friendlyFieldName = '';
                let fieldId = 0;
                let fieldIdx = formFields.findIndex((f: any) => f.fieldName === field);
                if (fieldIdx === -1 && field.includes('-')) {
                    // Repeatable section fields (e.g. SiteViews-0-ST_VIEW) are listed in formFields under their base name only.
                    const baseFieldName = field.split('-').pop();
                    fieldIdx = formFields.findIndex((f: any) => f.fieldName === baseFieldName);
                }
                if (fieldIdx !== -1) {
                    friendlyFieldName = formFields[fieldIdx]['friendlyFieldName'];
                    fieldId = formFields[fieldIdx]['fieldId'];
                } else if (Utils.isKeyInObject(MapDropdownFallbackFriendlyNames, field)) {
                    friendlyFieldName = MapDropdownFallbackFriendlyNames[field];
                }

                const fieldData = {
                    fieldName: field,
                    fieldId: fieldId,
                    friendlyFieldName: friendlyFieldName,
                    selectedData: selectedData,
                    sourceData: sourceData,
                };

                result.push(fieldData);
            }

            return result;
        },
        [CompAddressGettersV36.GetRepeatIndicesForSection]: (state: any) => (sectionName: string): number[] => {
            const repeatRegex = new RegExp(`^${sectionName}-(\\d+)-`);
            const indices = new Set<number>();
            const active = { ...state.activeComp };
            const dataSources = Object.keys(active).filter((key) => key.includes('sourceData'));

            for (const dataSource of dataSources) {
                // Transfer Data: sourceData
                if (dataSource.length === 10) {
                    for (const item of state.activeComp[dataSource]) {
                        const match = typeof item?.fieldName === 'string' ? item.fieldName.match(repeatRegex) : null;
                        if (match) {
                            indices.add(parseInt(match[1], 10));
                        }
                    }
                    // All other sources: sourceDataPR, sourceDataSE, etc
                } else if (!Utils.isObjectEmpty(state.activeComp[dataSource]) && Utils.isKeyInObject(state.activeComp[dataSource], 'sourceData')) {
                    for (const key of Object.keys(state.activeComp[dataSource]['sourceData'])) {
                        const match = key.match(repeatRegex);
                        if (match) {
                            indices.add(parseInt(match[1], 10));
                        }
                    }
                }
            }

            return Array.from(indices).sort((a, b) => a - b);
        },
        [CompAddressGettersV36.ActiveCompFieldData]: (state: any) => (fieldName: string) => {
            let result = {};
            const idx = state.activeComp.sourceData.findIndex((f: any) => f.fieldName === fieldName);
            if (idx !== -1) {
                result = state.activeComp.sourceData[idx];
            }
            return result;
        },
        [CompAddressGettersV36.ActiveCompFieldDataByFieldId]: (state: any) => (fieldId: number) => {
            let result = {};
            const idx = state.activeComp.sourceData.findIndex((f: any) => f.fieldId === fieldId);
            if (idx !== -1) {
                result = state.activeComp.sourceData[idx];
            }
            return result;
        },
        [CompAddressGettersV36.OnlyShowReportRows](state: any): boolean {
            return state.onlyShowReportRows;
        },
        [CompAddressGettersV36.OnlyShowDiscrepancyRows](state: any): boolean {
            return state.onlyShowDiscrepancyRows;
        },
        [CompAddressGettersV36.ActiveCompEmptySourceData](state: any): string[] {
            const sourceDataEmpty: string[] = [];
            const activeComp = state.activeComp;
            if (!activeComp || typeof activeComp !== 'object') {
                return sourceDataEmpty;
            }
            const emptySources = Object.keys(activeComp)
                .filter(function (k) {
                    return k.indexOf('source') === 0;
                })
                .reduce(function (newData: any, k) {
                    newData[k] = activeComp[k];
                    return newData;
                }, {});

            for (const sourceProperyName in emptySources) {
                const initials = sourceProperyName.slice(10);
                if (initials) {
                    if (Utils.isKeyInObject(activeComp, sourceProperyName)) {
                        if (!Utils.isObjectEmpty(activeComp[sourceProperyName])) {
                            if (Utils.isKeyInObject(activeComp[sourceProperyName], 'sourceData')) {
                                if (Utils.isObjectEmpty(activeComp[sourceProperyName].sourceData)) {
                                    sourceDataEmpty.push(initials);
                                }
                            }
                        } else {
                            sourceDataEmpty.push(initials);
                        }
                    }
                }
            }

            return sourceDataEmpty;
        },
        [CompAddressGettersV36.GetFakeData](state: any): ISourceData {
            return state.fakeData ? state.fakeData : {};
        },
        [CompAddressGettersV36.ActiveCompFieldFillerCount](state: any): number {
            return state.activeCompFieldFillerCount ? state.activeCompFieldFillerCount : 0;
        },
        [CompAddressGettersV36.ActiveCompSourceCounts](state: any): IFeedData[] {
            return state.activeCompSourceCounts ? state.activeCompSourceCounts : [];
        },
        [CompAddressGettersV36.IsSEColumnCollasped](state: any): boolean {
            return state.activeCompIsSECollapsed;
        },
        [CompAddressGettersV36.IsDBColumnCollasped](state: any): boolean {
            return state.activeCompIsDBCollapsed;
        },
    },

    mutations: {
        [CompAddressMutationsV36.LocalDatabaseComps](state: any, comp: IComp) {
            state.localDatabaseComps.push(comp);
        },
        [CompAddressMutationsV36.UpdateComp](state: any, comp: IComp) {
            state.comps.push(comp);
            state.comps.sort((a: IComp, b: IComp) => {
                const aIsSubject = String(a.compType ?? '').toLowerCase() === 'subject' ? 0 : 1;
                const bIsSubject = String(b.compType ?? '').toLowerCase() === 'subject' ? 0 : 1;
                if (aIsSubject !== bIsSubject) return aIsSubject - bIsSubject;
                return (a.compNumber ?? 0) - (b.compNumber ?? 0);
            });
        },
        [CompAddressMutationsV36.UpdateHasComps](state: any, value: boolean) {
            state.hasComps = value;
        },
        [CompAddressMutationsV36.UpdateCompFeedData](state: any, updateRequest: UpdateFeedRequest) {
            const itemIdx = state.comps.findIndex((f: any) => f.qsGuid === updateRequest.qsGuid);
            if (itemIdx !== -1) {
                switch (updateRequest.sourceInitial.toLowerCase()) {
                    case SourceDataInitials.Database:
                        state.comps[itemIdx].sourceDataDB = updateRequest.feedData;
                        break;
                    case SourceDataInitials.SmartExchange:
                        state.comps[itemIdx].sourceDataSE = updateRequest.feedData;
                        break;
                    case SourceDataInitials.PublicRecords:
                        state.comps[itemIdx].sourceDataPR = updateRequest.feedData;
                        break;
                    case SourceDataInitials.Mls:
                        state.comps[itemIdx].sourceDataMLS = updateRequest.feedData;
                        break;
                }
            }
        },
        [CompAddressMutationsV36.UpdateLocalVersions](state: any, payload: any) {
            const itemIdx = state.comps.findIndex((f: any) => f.qsGuid === payload.qsGuid);
            if (itemIdx !== -1) {
                state.comps[itemIdx].localVersions = payload.localVersions;
            }
        },
        [CompAddressMutationsV36.ResetCompLoading](state: any, qsGuid: string) {
            const itemIdx = state.comps.findIndex((f: any) => f.qsGuid === qsGuid);
            if (itemIdx !== -1) {
                state.comps[itemIdx].isLoading = false;
            }
        },
        [CompAddressMutationsV36.UpdateRemoveComp](state: any, idx: number) {
            state.comps.splice(idx, 1);
        },
        [CompAddressMutationsV36.UpdateMoveComp](state: any, indexes: DoubleIndex) {
            state.comps = Utils.moveArrayItem(state.comps, indexes.source, indexes.target);
        },
        [CompAddressMutationsV36.UpdateActiveComp](state: any, idx: number) {
            if (Utils.isKeyInObject(state.comps, idx)) {
                state.comps[idx].isActive = true;
                state.activeComp = state.comps[idx];
            } else {
                state.comps[0].isActive = true;
                state.activeComp = state.comps[0];
            }
            state.activeComp.hasVisited = true;
        },
        [CompAddressMutationsV36.ResetActiveComp](state: any) {
            for (const idx in state.comps) {
                state.comps[idx].isActive = false;
            }
        },
        // Silently points state.activeComp at a different comp so DataGrid watchers fire
        // without changing any comp's isActive flag — tab highlights stay unchanged.
        [CompAddressMutationsV36.SetSilentActiveComp](state: any, idx: number) {
            if (Utils.isKeyInObject(state.comps, idx)) {
                state.activeComp = state.comps[idx];
            }
        },
        [CompAddressMutationsV36.ResetCompNumber](state: any) {
            for (const idx in state.comps) {
                state.comps[idx].compNumber = Number(idx);
            }
        },
        [CompAddressMutationsV36.UpsertCompSourceDataByFieldId](state: any, request: IUpsertCompDataRequest) {
            const storeComp: IComp = store.getters[Getters.CompAddressesV36.CompByAddress](request.comp.address);

            if (storeComp) {
                if (!storeComp.sourceData) {
                    storeComp.sourceData = [];
                }

                const compData = storeComp.sourceData.find((cd) => cd.fieldId === request.fieldId);
                if (compData) {
                    // const logMsg = `CompAddressStoreV36.UpsertCompSourceDataByFieldId() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}]`;
                    // if (request.fieldName !== FieldNames.CompPhoto) {
                    //     console.log(`${logMsg}, field[${request.fieldId}], request[${JSON.stringify(_.omit(request, ['comp', 'description']))}]`);
                    // } else {
                    //     console.log(`${logMsg}, field[${request.fieldId},COMP_PHOTO], request[${JSON.stringify(_.omit(request, ['comp', 'description', 'value']))}]`);
                    // }
                    _.assign(compData, _.omit(request, ['comp', 'description']));
                } else {
                    console.log(`CompAddressStoreV36.UpsertCompSourceDataByFieldId() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}], Store comp data not found for field[${request.fieldId}]`);
                }
            } else {
                console.log(`CompAddressStoreV36.UpsertCompSourceDataByFieldId() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}], Store comp not found`);
            }
        },
        [CompAddressMutationsV36.UpsertCompSourceDataBatchByFieldId](state: any, payload: any) {
            const storeComp: IComp = store.getters[Getters.CompAddressesV36.CompByAddress](payload.comp.address);

            if (!storeComp) {
                console.log(`CompAddressStoreV36.UpsertCompSourceDataBatchByFieldId() ${payload.description ? 'from ' + payload.description : ''}, address[${CompAddressUtils.getShortDescription(payload.comp.address)}], Store comp not found`);
                return;
            }

            if (!storeComp.sourceData || !Array.isArray(payload.updates) || payload.updates.length === 0) {
                return;
            }

            const updatesByFieldId = new Map<number, any>();
            for (const update of payload.updates) {
                if (update && update.fieldId !== undefined && update.fieldId !== null) {
                    updatesByFieldId.set(update.fieldId, update);
                }
            }

            for (const compData of storeComp.sourceData) {
                const update = updatesByFieldId.get(compData.fieldId);
                if (update) {
                    _.assign(compData, _.omit(update, ['fieldId']));
                }
            }
        },
        [CompAddressMutationsV36.UpsertCompSourceDataBatchByFieldName](state: any, payload: any) {
            const storeComp: IComp = store.getters[Getters.CompAddressesV36.CompByAddress](payload.comp.address);
            if (!storeComp || !Array.isArray(payload.updates) || payload.updates.length === 0) {
                return;
            }

            if (!storeComp.sourceData) {
                storeComp.sourceData = [];
            }

            for (const update of payload.updates) {
                let compData = storeComp.sourceData.find((item) => item.fieldName === update.fieldName);
                if (!compData) {
                    compData = newCompData();
                    storeComp.sourceData.push(compData);
                }
                _.assign(compData, update);
            }
        },
        [CompAddressMutationsV36.UpsertCompSourceDataByFieldName](state: any, request: IUpsertCompDataRequest) {
            const storeComp: IComp = store.getters[Getters.CompAddressesV36.CompByAddress](request.comp.address);

            if (storeComp) {
                if (!storeComp.sourceData) {
                    storeComp.sourceData = [];
                }

                // const logMsg = `CompAddressStoreV36.UpsertCompSourceDataByFieldName() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}]`;

                let compData = storeComp.sourceData.find((cd) => cd.fieldName === request.fieldName);
                if (compData) {
                    // if (request.fieldName !== FieldNames.CompPhoto) {
                    //     console.log(`${logMsg}, Updating field[${request.fieldName}], request[${JSON.stringify(_.omit(request, ['comp', 'description']))}]`);
                    // } else {
                    //     console.log(`${logMsg}, Updating field[${request.fieldName},COMP_PHOTO], request[${JSON.stringify(_.omit(request, ['comp', 'description', 'value']))}]`);
                    // }

                    _.assign(compData, _.omit(request, ['comp', 'description']));
                } else {
                    // if (request.fieldName !== FieldNames.CompPhoto) {
                    //     console.log(`${logMsg}, Adding field[${request.fieldName}], request[${JSON.stringify(_.omit(request, ['comp', 'description']))}]`);
                    // } else {
                    //     console.log(`${logMsg}, Adding field[${request.fieldName},COMP_PHOTO], request[${JSON.stringify(_.omit(request, ['comp', 'description', 'value']))}]`);
                    // }

                    compData = newCompData();
                    _.assign(compData, _.omit(request, ['comp', 'description']));
                    storeComp.sourceData.push(compData);
                }
            } else {
                console.log(`CompAddressStoreV36.UpsertCompSourceDataByFieldName() ${request.description ? 'from ' + request.description : ''}, address[${CompAddressUtils.getShortDescription(request.comp.address)}], Store comp not found`);
            }
        },
        [CompAddressMutationsV36.UpsertCompSourceDataValueByFieldName](state: any, payload: any) {
            const compIdx = store.getters[Getters.CompAddressesV36.CompIdxByAddress](payload.comp.address);
            if (compIdx !== -1) {
                const itemIdx = payload.comp.sourceData.findIndex((f: any) => f.fieldName === payload.fieldName);
                if (itemIdx !== -1) {
                    state.comps[compIdx].sourceData[itemIdx][payload.name] = payload.value;
                } else {
                    state.comps[compIdx].sourceData.push({ fieldName: payload.fieldName, [payload.name]: payload.value });
                }
            }
        },
        [CompAddressMutationsV36.AddCompData](state: any, payload: IAddCompDataRequest) {
            const compIdx = store.getters[Getters.CompAddressesV36.CompIdxByAddress](payload.compAddress);
            if (compIdx === -1) {
                return;
            }

            const stateComp: IComp = state.comps[compIdx];
            if (!stateComp.sourceData) {
                stateComp.sourceData = [];
            }

            for (const compData of payload.compDatas) {
                // No duplicates, so check existence by field name (not all have a field id)
                const idx = stateComp.sourceData.findIndex((cd) => cd.fieldName === compData.fieldName);
                if (idx === -1) {
                    // console.log(`CompAddressStoreV36.AddCompData(), address[${CompAddressUtils.getShortDescription(payload.compAddress)}], compData[${JSON.stringify(compData)}]`);
                    stateComp.sourceData.push(compData);
                }
            }
        },
        [CompAddressMutationsV36.UpdateCompMLS](state: any, payload: any) {
            state.comps[payload.idx].sourceDataMLS = payload.mlsData;
        },
        [CompAddressMutationsV36.OnlyShowReportRows](state: any, isActive: boolean) {
            state.onlyShowReportRows = isActive;
        },
        [CompAddressMutationsV36.OnlyShowDiscrepancyRows](state: any, isActive: boolean) {
            state.onlyShowDiscrepancyRows = isActive;
        },
        [CompAddressMutationsV36.UpdateAdditionalField](state: any, payload: any) {
            const comp = state.comps[0];
            const request = newUpsertCompDataRequestByFieldName(comp, payload.fieldName);
            request.value = payload.value;
            request.description = 'CompAddressStoreV36.UpdateAdditionalField()';
            store.commit(Mutations.CompAddressesV36.UpsertCompSourceDataByFieldName, request);
        },
        [CompAddressMutationsV36.SetFakeData](state: any, sourceData: ISourceData) {
            state.fakeData = sourceData;
        },
        [CompAddressMutationsV36.UpdateInsertNotes](state: any, payload: ICommonFieldData) {
            if (state.activeComp.notesData) {
                const itemIdx = state.activeComp.notesData.findIndex((x: { fieldName: { toString: () => any } }) => x.fieldName === payload.fieldName);
                if (itemIdx !== -1) {
                    state.activeComp.notesData[itemIdx] = payload;
                } else {
                    state.activeComp.notesData.push(payload);
                }
            } else {
                // notesData is null.  Notes have never been saved
                state.activeComp.notesData = [];
                state.activeComp.notesData.push(payload);
            }
        },
        [CompAddressMutationsV36.ActiveCompFieldFillerCount](state: any, count: number) {
            state.activeCompFieldFillerCount = count;
        },
        [CompAddressMutationsV36.ActiveCompSourceCounts](state: any, payload: IFeedData[]) {
            state.activeCompSourceCounts = payload;
        },
        [CompAddressMutationsV36.AddSubComp](state: any, payload: any) {
            const idx = store.getters[Getters.CompAddressesV36.CompIdxByAddress](payload.comp.address);
            if (idx !== -1) {
                if (!state.comps[idx].subCompData) {
                    state.comps[idx].subCompData = {};
                }

                if (!Utils.isKeyInObject(state.comps[idx].subCompData, payload.initials)) {
                    state.comps[idx].subCompData[payload.initials] = [];
                }

                state.comps[idx].subCompData[payload.initials].push(payload.sourceData);
            }
        },
        [CompAddressMutationsV36.ClearSubComps](state: any, payload: any) {
            const idx = store.getters[Getters.CompAddressesV36.CompIdxByAddress](payload.comp.address);
            if (idx !== -1) {
                if (state.comps[idx].subCompData && Utils.isKeyInObject(state.comps[idx].subCompData, payload.initials)) {
                    delete state.comps[idx].subCompData[payload.initials];
                }
            }
        },

        [CompAddressMutationsV36.SetSEColumnCollasped](state: any, value: boolean) {
            state.activeCompIsSECollapsed = value;
        },
        [CompAddressMutationsV36.SetDBColumnCollasped](state: any, value: boolean) {
            state.activeCompIsDBCollapsed = value;
        },
        [CompAddressMutationsV36.ClearCompSourceData](state: any, payload: IClearSourceDataRequest) {
            const comp: IComp = store.getters[Getters.CompAddressesV36.CompByAddress](payload.comp.address);
            if (comp) {
                for (const sourceInitial of payload.sourceInitials) {
                    // console.log(`CompAddressStoreV36.ClearCompSourceData, Clearing [${sourceInitial}] feed data on[${CompAddressUtils.getShortDescription(comp.address)}]`);

                    switch (sourceInitial) {
                        case SourceDataInitials.PublicRecords:
                            if (comp.sourceDataPR && comp.sourceDataPR.sourceData) {
                                const keys = Object.keys(comp.sourceDataPR.sourceData);
                                for (const key of keys) {
                                    comp.sourceDataPR.sourceData[key] = '';
                                }
                            }
                            break;
                        case SourceDataInitials.Mls:
                            if (comp.sourceDataMLS && comp.sourceDataMLS.sourceData) {
                                const keys = Object.keys(comp.sourceDataMLS.sourceData);
                                for (const key of keys) {
                                    comp.sourceDataMLS.sourceData[key] = '';
                                }
                            }
                            break;
                        case SourceDataInitials.SmartExchange:
                            if (comp.sourceDataSE && comp.sourceDataSE.sourceData) {
                                const keys = Object.keys(comp.sourceDataSE.sourceData);
                                for (const key of keys) {
                                    comp.sourceDataSE.sourceData[key] = '';
                                }
                            }
                            break;
                        case SourceDataInitials.Database:
                            if (comp.sourceDataDB && comp.sourceDataDB.sourceData) {
                                const keys = Object.keys(comp.sourceDataDB.sourceData);
                                for (const key of keys) {
                                    comp.sourceDataDB.sourceData[key] = '';
                                }
                            }
                            break;
                    }
                }
            }
        },
    },
};
